import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import {
  DocumentTypeCodeDto,
  DocumentTypeDto,
  FiscalFileLocationDto,
  LandTitleRegisterDto,
  SecurityClassificationDto,
} from '@cradua/data';
import { DocumentoperationsComponent } from '../../../../../generic-document/src/lib/components/documentoperations/documentoperations.component';
import { fadeInAnimation } from 'libs/shared/src/lib/_animations/fade-in.animation';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';
import { DocumentFacade } from '../../../../../generic-document/src/lib/document-states/document.facade';
import { Guid } from 'guid-typescript';
import * as XLSX from 'xlsx';
import { ExcelDocumentUploadViewComponent } from 'libs/adr-management/src/lib/components/document/document-table/excel-document-upload-view/excel-document-upload-view.component';
type AOA = any[][];

@Component({
  selector: 'app-response-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
  animations: [fadeInAnimation],
})
export class DocumentComponent implements OnInit {
  documentForm: FormGroup;
  @Input() selected$: Observable<any>;
  @Input() selected: any;
  @Input() uploadType: string;
  @Output() emitUpload = new EventEmitter<any>();
  selectedDocument: LandTitleRegisterDto;
  securityclassifications$: Observable<any>;
  documenttypes$: Observable<any>;
  documenttypecodes$: Observable<any>;
  filelocations$: Observable<any>;
  isLoadingDocument: Boolean;
  isLoadingDocument$: Observable<Boolean>;
  isReady: Boolean;
  hasFailed: Boolean;
  selectedIndex = null;
  fileExist: Boolean;
  completed: Boolean;
  isInProgress: Boolean;
  @Input() selectedRegisterId: string;
  docs: any[] = [];
  listView = true;
  gridView = false;
  securityClassifications: any;
  documentTypes: any;
  documentTypeCodes: any;
  fileLocations: any;
  uploadDocuments: any;
  fileName = 'SheetJS.xlsx';
  showClose = false;
  constructor(
    private fb: FormBuilder,
    private gatwayFacade: GatewayFacade,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data,
    private documentFacade: DocumentFacade
  ) {}

  ngOnInit() {
    console.log('Dialog Data: ', this.data);
    if (this.data) {
      this.showClose = true;
    }
    this.securityclassifications$ = this.gatwayFacade.loadGateway(
      'SecurityClassification'
    );

    this.loadDocuments(this.data);

    this.documenttypes$ = this.gatwayFacade.loadGateway('DocumentType');
    this.documenttypecodes$ = this.gatwayFacade.loadGateway('DocumentTypeCode');
    this.filelocations$ = this.gatwayFacade.loadGateway('FiscalFileLocation');
    this.securityclassifications$.subscribe((a) => {
      console.log('SecClas: ', a);
      this.securityClassifications = a;
    });
    this.documenttypecodes$.subscribe((s) => {
      console.log('DocTypeCodes: ', s);
      this.documentTypeCodes = s;
    });
    this.filelocations$.subscribe((f) => {
      console.log('File location: ', f);
      this.fileLocations = f;
    });
    this.documenttypes$.subscribe((doc) => {
      console.log('DocTypes: ', doc);
      this.documentTypes = doc;
    });
    // this.selectedPipelineEncroachment$.subscribe(
    //   (selectedPipelineEncroachment) => {
    //     this.selectedPipelineEncroachment = selectedPipelineEncroachment;
    //     console.log(
    //       'selectedPipelineLicenseReq: ',
    //       selectedPipelineEncroachment
    //     );
    //   }
    // );
    console.log('selectedPipelineLicenseReq: ', this.selected);
    this.createDocumentForm();
  }
  toggleView() {
    this.listView = !this.listView;
    this.gridView = !this.gridView;
  }
  doesFileExistwithURL() {}
  onFilesAdded(event) {
    const file = event.target.files[0];
    console.log('Doc file: ', file.name);
    this.documentForm.patchValue({
      FilePath: file,
      FileName: file?.name?.split('.')[0],
      FileType: file?.type,
      LandTitleCode: this.data ? this.data : this.selected.id,
    });
    console.log('Doc Form: ', this.documentForm.value);
  }
  onReset() {}
  createDocumentForm() {
    this.documentForm = this.fb.group({
      DocumentTitle: ['', Validators.required],
      DocumentTypeCodeId: ['', Validators.required],
      DocumentTypeId: ['', Validators.required],
      SecurityId: null,
      FileLocationId: null,
      Remarks: null,
      Url: null,
      FileName: ['', Validators.required],
      FilePath: [''],
      FileType: [''],
      ApprovalStatus: ['NOT APPROVED'],
      LandTitleCode: this.selected?.id,
      id: null,
    });
  }
  get documentArray() {
    return this.fb.array(
      [],

      this.fb.group({
        DocumentTitle: ['', Validators.required],
        DocumentTypeCodeId: ['', Validators.required],
        DocumentTypeId: ['', Validators.required],
        SecurityId: null,
        FileLocationId: null,
        Remarks: null,
        Url: null,
        FileName: ['', Validators.required],
        FilePath: [''],
        FileType: [''],
        ApprovalStatus: ['NOT APPROVED'],
        LandTitleCode: this.selected ? this.selected.id : this.data,
        id: null,
      })
    );
  }
  uploadFile(event) {
    const file = event.target.files[0];
    this.documentForm.patchValue({
      FileName: file.name,
      FileType: file.type,
      FilePath: file,
      DocumentType: 'Encroacher',
    });
    this.emitUpload.emit(this.documentForm.value);
    // const reader: FileReader = new FileReader();
    //  reader.onload = ()=>{

    // }
  }

  uploadMultiple(event) {
    const files = event.target.files;
    console.log('Docs', this.documentArray.value);
  }
  onSelectDoc(doc: LandTitleRegisterDto) {
    this.selectedDocument = doc;
    this.documentForm.patchValue(doc);
    if (doc.FilePath === null) {
      return;
    }
    const dialogConfig = new MatDialogConfig();

    // dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '100%';
    dialogConfig.width = '100%';
    // dialogConfig.minHeight = '100vh';
    // dialogConfig.minWidth = '100%'
    // dialogConfig.panelClass = "custom-dialog-container";
    // dialogConfig.backdropClass = "backdropBackground";
    dialogConfig.data = {
      doc,
    };
    console.log('Dialog Config: ', dialogConfig);
    const dialogRef = this.dialog.open(
      DocumentoperationsComponent,
      dialogConfig
    );
  }
  onSubmit() {
    this.isInProgress = true;
    console.log('Form: ', this.documentForm.value);
    const docs = this.documentForm.value;
    docs.id = Guid.create().toString();
    docs.DocumentTypeCodeId = this.selected ? this.selected.id : this.data;
    const { FilePath, ...doc } = docs;
    if (typeof FilePath === 'string') {
      doc['FilePath'] = FilePath;
    }
    doc['type'] = 'landTitleRegister';
    const savedDoc = this.documentFacade.uploadSingleDocumentWithFile(
      doc,
      FilePath
    );
    this.completed = true;
    this.isInProgress = false;
    this.loadDocuments();
  }

  loadDocuments(id?) {
    console.log('Loading document with id: ', id);
    this.isLoadingDocument$ = this.documentFacade.isLoadingDocumentById(
      id ? id : this.selected.id
    );
    this.documentFacade.loadClearDocument().subscribe((docs) => {
      this.docs = docs;
      console.log('Documents: ', docs);
    });
  }

  protected filterById = <T>(id: string, lookupId: string) => (fieldName: T) =>
    fieldName[lookupId] === id;

  getDocumentTypeName(id: string) {
    const found = this.documentTypes.find(
      this.filterById<DocumentTypeDto>(id, 'id')
    );
    return found ? found.DocumentTypeName : null;
  }

  getDocumentTypeCodeName(id: string) {
    const found = this.documentTypeCodes.find(
      this.filterById<DocumentTypeCodeDto>(id, 'id')
    );
    return found ? found.DocumentTypeCodeName : null;
  }

  getSecurityClassificationName(id: string) {
    const found = this.securityClassifications.find(
      this.filterById<SecurityClassificationDto>(id, 'id')
    );
    return found ? found.SecurityClassificationName : null;
  }

  getFileLocationName(id: string) {
    const found = this.fileLocations.find(
      this.filterById<FiscalFileLocationDto>(id, 'id')
    );
    return found ? found.FileLocationName : null;
  }
  onUploadDoc(doc) {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '90%';
    dialogConfig.width = '100%';
    // dialogConfig.minHeight = '100vh';
    // dialogConfig.minWidth = '100%'
    dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.backdropClass = 'backdropBackground';

    dialogConfig.data = {
      doc,
      documentTypes: this.documentTypes,
      documentTypeCodes: this.documentTypeCodes,
      securityClassifications: this.securityClassifications,
      fileLocations: this.fileLocations,
    };

    const dialogRef = this.dialog.open(
      ExcelDocumentUploadViewComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      // console.log('result got ', result);
      if (result !== undefined) {
        this.uploadDocuments = result;

        const transformDoc = result.map((doc) => {
          if (doc.id != null) {
            return {
              DocumentTitle: doc.DocumentTitle,
              DocumentTypeCodeId: this.getDocumentTypeCodeId(
                doc.DocumentTypeCode
              ),
              DocumentTypeId: this.getDocumentTypeId(doc.DocumentType),
              SecurityId: this.getSecurityId(doc.Security),
              FileLocationId: this.getFileLocationId(doc.FileLocation),
              Remarks: doc.Remarks,
              Url: doc.Url,
              FileName: doc.FileName,
              DocRefNo: doc.DocRefNo,
              FilePath: doc.FilePath,
              FileType: doc.FileType,
              id: doc.id,
            };
          } else {
            return {
              DocumentTitle: doc.DocumentTitle,
              DocumentTypeCodeId: this.getDocumentTypeCodeId(
                doc.DocumentTypeCode
              ),
              DocumentTypeId: this.getDocumentTypeId(doc.DocumentType),
              SecurityId: this.getSecurityId(doc.Security),
              FileLocationId: this.getFileLocationId(doc.FileLocation),
              Remarks: doc.Remarks,
              Url: doc.Url,
              FileName: doc.FileName,
              DocRefNo: doc.DocRefNo,
              FilePath: doc.FilePath,
              FileType: doc.FileType,
              LandTitleCode: this.data ? this.data : this.selected.id,
              id: doc.id,
            };
          }
        });
        console.log('result got 1', transformDoc);
        // this.emitSaveManyDoc.emit(transformDoc);
      }
    });
  }

  export(): void {
    const transformDoc = this.docs.map((doc) => {
      return {
        id: doc.id,
        DocumentTitle: doc.DocumentTitle,
        DocumentTypeCode: this.getDocumentTypeCodeName(doc.DocumentTypeCodeId),
        DocumentType: this.getDocumentTypeName(doc.DocumentTypeId),
        Security: this.getSecurityClassificationName(doc.SecurityId),
        FileLocation: this.getFileLocationName(doc.FileLocationId),
        Remarks: doc.Remarks,
        Url: doc.Url,
        DocRefNo: doc.DocRefNo,
        FileName: doc.FileName,
        FilePath: doc.FilePath,
        FileType: doc.FileType,
      };
    });
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(transformDoc);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Doc');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  getDocumentTypeId(value: string) {
    if (value) {
      const foundDocumentType = this.documentTypes.find(
        (docType) =>
          docType.DocumentTypeName &&
          docType.DocumentTypeName.trim().toLowerCase() ===
            value.trim().toLowerCase()
      );
      return foundDocumentType ? foundDocumentType.id : null;
    } else {
      return null;
    }
  }

  getDocumentTypeCodeId(value: string) {
    if (value) {
      const foundDocumentTypeCode = this.documentTypeCodes.find(
        (docTypeCode) =>
          docTypeCode.DocumentTypeCodeName &&
          docTypeCode.DocumentTypeCodeName.trim().toLowerCase() ===
            value.trim().toLowerCase()
      );
      return foundDocumentTypeCode ? foundDocumentTypeCode.id : null;
    } else {
      return null;
    }
  }

  getFileLocationId(value: string) {
    if (value) {
      const foundFileLocation = this.fileLocations.find(
        (fileLocation) =>
          fileLocation.FileLocationName &&
          fileLocation.FileLocationName.trim().toLowerCase() ===
            value.trim().toLowerCase()
      );

      return foundFileLocation ? foundFileLocation.id : null;
    } else {
      return null;
    }
  }

  getSecurityId(value: string) {
    if (value) {
      const foundSecurityClassification = this.securityClassifications.find(
        (securityClassification) =>
          securityClassification.SecurityClassificationName &&
          securityClassification.SecurityClassificationName.trim().toLowerCase() ===
            value.trim().toLowerCase()
      );

      return foundSecurityClassification
        ? foundSecurityClassification.id
        : null;
    } else {
      return null;
    }
  }
  closeDialog() {
    this.dialog.closeAll();
  }
}

// ${randomize('0', 6)}`
